import { AuthService } from './../_services/auth.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Routes } from '../_config/routes.config';

@Injectable({
  providedIn: 'root'
})
export class EnrollmentGuard implements CanActivate {

  private tokenData: any;

  constructor(private router: Router, private authService:AuthService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      this.tokenData = this.authService.getTokenData();

      if (this.tokenData && this.tokenData.enrollment === 'True') {
        return true; // El usuario ha completado el enrollment, permitir acceso
      }

      // Si la pagina actual es Languages (Primera pag de enrollment), permite el acceso
      if (state.url === Routes.ENROLLMENT) {
        return true;
      }

      // Redirigir a Languages (primera pagina de enrollment) si el usuario no ha completado el enrollment.
      this.router.navigate([Routes.ENROLLMENT]);
      return false;
    }
  }
